





















































import { Component, Inject, Vue } from 'vue-property-decorator'
import { TypeformCredentials } from '@/api/model/credentials'
import { CredentialsType } from '@/api/types'
import { CompanyAPI } from '@/api/backend-client'
import { TypeformAPI } from '@/api/client/typeform'

@Component
export default class CompanySettingsTypeformGeneral extends Vue {
    @Inject() readonly reloadCompany: () => Promise<void>
    currentCredentials: TypeformCredentials = null
    credentials: TypeformCredentials = null
    loading: boolean = false

    async created() {
        await this.reload()
    }

    async reload() {
        this.loading = true

        const credentials = this.$currentCompany.getCredentialsWithType(CredentialsType.TYPEFORM)
        if (credentials.length) {
            this.currentCredentials = credentials[0] as TypeformCredentials
            this.currentCredentials.company = this.$currentCompany
        }

        if (!this.currentCredentials) {
            this.currentCredentials = TypeformCredentials.create({
                company: this.$currentCompany,
                createdBy: this.$currentUser,
                updatedBy: this.$currentUser,
            })
        }

        this.credentials = this.currentCredentials.clone()
        this.credentials.updatedBy = this.$currentUser

        this.loading = false
    }

    get isActivated(): boolean {
        return this.currentCredentials.workspaceId !== null
    }

    async activate() {
        try {
            this.loading = true
            await CompanyAPI.updateTypeformCredentials(this.$currentCompany.id, this.credentials)
            await TypeformAPI.activate(this.credentials)
            await this.reloadCompany()
            await this.reload()
        } finally {
            this.loading = false
        }
    }

    async save() {
        try {
            this.loading = true
            await CompanyAPI.updateTypeformCredentials(this.$currentCompany.id, this.credentials)
            await this.reloadCompany()
            await this.reload()
        } finally {
            this.loading = false
        }
    }
}
